var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneDayList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48148 1.11111C1.72115 1.11111 1.11111 1.74431 1.11111 2.48148V17.5185C1.11111 18.2789 1.74431 18.8889 2.48148 18.8889H17.5185C18.2857 18.8889 18.8948 18.2835 18.9259 17.5448V2.48148C18.9259 1.72115 18.2927 1.11111 17.5556 1.11111H2.48148ZM0 2.48148C0 1.14458 1.09367 0 2.48148 0H17.5556C18.8925 0 20.037 1.09367 20.037 2.48148V17.5655L20.0367 17.5754C19.9891 18.9067 18.8963 20 17.5185 20H2.48148C1.14458 20 0 18.9063 0 17.5185V2.48148Z",
    fill: "#524F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6291 5.18533H0.740234V4.07422H19.6291V5.18533Z",
    fill: "#524F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.2958C17 11.6026 16.7513 11.8513 16.4444 11.8513H3.55556C3.24873 11.8513 3 11.6026 3 11.2958C3 10.989 3.24873 10.7402 3.55556 10.7402H16.4444C16.7513 10.7402 17 10.989 17 11.2958Z",
    fill: "#524F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.25C4.5 9.83579 4.16421 9.5 3.75 9.5C3.33579 9.5 3 9.83579 3 10.25V12.25C3 12.6642 3.33579 13 3.75 13C4.16421 13 4.5 12.6642 4.5 12.25V10.25Z",
    fill: "#524F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDayList);
export default __webpack_public_path__ + "static/media/one-day-list.20cebcbcaa207ea44dfa14abb425c8e7.svg";
export { ForwardRef as ReactComponent };